export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Secure Finance Made Right',
  headline: 'Mirai Is An User-Friendly Mobile Wallet That...',
  description:
    ' Makes anyone have the ability to transfer USD or cryptocurrencies, right from your phone! No need to download any apps, login straight from the web! Mirai in Japanese means future, hence our service is your future of finance!',
  buttonLabel: 'Get Started',
  imgStart: false,
  img: require('../../images/Website Logo .png'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
};

export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Unlimited Secure Access',
  headline: 'Login to your account at any time on any device!',
  description:
    'We have you covered no matter where you are located. All you need is an internet connection and a supported device! The best part is that our services are always making sure that you are secure, without you even knowing! ',
  buttonLabel: 'Back to Top',
  imgStart: true,
  img: require('../../images/Discover.jpg'),
  alt: 'image',
  dark: false,
  primary: false,
  darkText: true
};

export const homeObjThree = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Join our wallet community!',
  headline: 'Creating an account is extremely easy and fast',
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
    buttonLabel: 'Start Now' ,
  imgStart: false,
  img: require('../../images/Checklist.png'),
  alt: 'checklist',
  dark: false,
  primary: false,
  darkText: true
};
